// extracted by mini-css-extract-plugin
export default {"cls1":"UXavsEmsMipsCCi3J_34","cls2":"WqUKZSzsIQ4_0S6sVYsG UXavsEmsMipsCCi3J_34"};